'use strict';


import { getLoginRequiredResolveObj } from "../shared/utils/angularUtils";
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';

export const paymentModule = angular.module(
  'app.payment',
  []
).config(paymentConfig);

paymentConfig.$inject = ['$routeProvider'];

function paymentConfig($routeProvider) {
  $routeProvider
    .when('/checkout', {
      template: '<ngz-checkout></ngz-checkout>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
    .when('/scan-iq-checkout', {
      template: '<ngz-checkout></ngz-checkout>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
    .when('/challenge-checkout', {
      template: '<ngz-challenge-checkout></ngz-challenge-checkout>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
    .when('/payment-result', {
      template: '<ngz-payment-result></ngz-payment-result>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
    .when('/scaniq-payment-result', {
      template: '<ngz-scan-iq-payment-result></ngz-scan-iq-payment-result>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
    .when('/challenge-payment-result', {
      template: '<ngz-challenge-payment-result></ngz-challenge-payment-result>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
    .when('/select-subscription', {
      template: '<ngz-select-subscription></ngz-select-subscription>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
    .when('/detailed-revenue', {
      template: '<ngz-detailed-revenue-page></ngz-detailed-revenue-page>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'Detailed Revenue', icon: NAVIGATION_ICON.INSERT_CHART }
        ]
      }
    })
    .when('/self-billing/setup-card', {
      template: '<ngz-self-billing-setup-card></ngz-self-billing-setup-card>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
      resolve: {
        setupCardRequired: ['AuthService', (AuthService) => AuthService.setupCardRequired()],
      },
    })
    .when('/self-billing/failed-payment', {
      template: '<ngz-self-billing-failed-payment></ngz-self-billing-failed-payment>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
      resolve: {
        failedPaymentRequired: ['AuthService', (AuthService) => AuthService.failedPaymentRequired()],
      },
    })
    .when('/subscriptions/nutrition', {
      template: '<ngz-nutrition-subscription-page></ngz-nutrition-subscription-page>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'Subscriptions', icon: NAVIGATION_ICON.ACCOUNT_BALANCE_WALLET }
        ]
      }
    })
    .when('/subscriptions/scan-iq', {
      template: '<ngz-scan-iq-subscription-page></ngz-scan-iq-subscription-page>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.SCAN_IQ,
        breadcrumbs: [
          { label: 'Subscriptions', icon: NAVIGATION_ICON.ACCOUNT_BALANCE_WALLET }
        ]
      }
    })
    .when('/subscriptions/challenge', {
      template: '<ngz-challenge-subscription-page></ngz-challenge-subscription-page>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.CHALLENGE,
        breadcrumbs: [
          { label: 'Billing Setup', icon: NAVIGATION_ICON.ATTACH_MONEY }
        ]
      }
    })
    .when('/promo-codes/nutrition', {
      template: '<ngz-nutrition-promo-codes-page></ngz-nutrition-promo-codes-page>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'Promo Codes', icon: NAVIGATION_ICON.PERCENT }
        ]
      }
    })
    .when('/promo-codes/scan-iq', {
      template: '<ngz-scan-iq-promo-codes-page></ngz-scan-iq-promo-codes-page>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.SCAN_IQ,
        breadcrumbs: [
          { label: 'Promo Codes', icon: NAVIGATION_ICON.PERCENT }
        ]
      }
    });
}
